import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sheet", "backdrop", "content"]
  static values = { open: { type: Boolean, default: false } }

  toggle() {
    if (this.openValue) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.openValue = true
    this.sheetTarget.classList.remove("hidden")
    this.backdropTarget.classList.remove("hidden")
    // Trigger animation on next frame
    requestAnimationFrame(() => {
      this.contentTarget.classList.add("bottom-sheet-enter")
      this.backdropTarget.classList.add("opacity-100")
      this.backdropTarget.classList.remove("opacity-0")
    })
  }

  close() {
    this.openValue = false
    this.backdropTarget.classList.add("opacity-0")
    this.backdropTarget.classList.remove("opacity-100")
    this.contentTarget.classList.remove("bottom-sheet-enter")
    setTimeout(() => {
      this.sheetTarget.classList.add("hidden")
      this.backdropTarget.classList.add("hidden")
    }, 300)
  }
}
